// @flow

import { DraftLiveStateEnum } from "@modules/service/constants";
import type { DynamicQuestionsState } from "./types";

export const initialState: DynamicQuestionsState = {
  requestsInProgress: 0,
  list: null,
  schema: null,
  current: null,
  draft: null,
  assignments: [],
  draftAssignments: [],
  configuration: {
    enabled: true,
    status: DraftLiveStateEnum.LIVE,
  },
  modals: {
    showAddDynamicQuestionModal: false,
    modalStep: 1,
    showEditModal: false,
    showSubmitModal: false,
    showCancelModal: false,
    showDiscardModal: false,
    showCancelDiscardModal: false,
    showDisableModal: false,
    showEditAssignmentsModal: false,
  },
};

export default initialState;
